import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IUpgamingState } from '../types'

const initialState: IUpgamingState['data'] = {
  sessionUrl: null,
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.createSession.success, (state, action) => {
      state.sessionUrl = action.payload
    })
    .addCase(actions.createGuestSession.success, (state, action) => {
      state.sessionUrl = action.payload
    })
})
